<template>
  <div>
    <div id="list" v-if="viewType == 'list'">
      <div class="row center-block">
        <div class="col-md-12">
          <div class="box">
            <div class="box-header">
              <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1"
                style="margin-top: 10px; text-align:left">Show</label>
              <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                  <option v-if="inquiryParam.pageSize == 5" selected>5</option>
                  <option v-else>5</option>
                  <option v-if="inquiryParam.pageSize == 10" selected>10</option>
                  <option v-else>10</option>
                  <option v-if="inquiryParam.pageSize == 20" selected>20</option>
                  <option v-else>20</option>
                  <option v-if="inquiryParam.pageSize == 50" selected>50</option>
                  <option v-else>50</option>
                  <option v-if="inquiryParam.pageSize == 100" selected>100</option>
                  <option v-else>100</option>
                </select>
              </div>
              <div class="box-tools">
                <button v-on:click="onCreate" class="btn btn-primary">Create</button>
                <button class="btn btn-default" data-toggle="modal" data-target="#modal-filter">Filter</button>
                <button v-on:click="inquiry" class="btn btn-warning">Search</button>
              </div>
            </div>
            <div class="box-body no-padding table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th style="width: 45px;text-align:center;">#</th>
                    <th style="text-align:center;">Action</th>
                    <th style="text-align:left;">Product Name</th>
                    <th style="text-align:center;">Valid From</th>
                    <th style="text-align:center;">Time</th>
                    <th style="text-align:right;">Price WeekDay</th>
                    <th style="text-align:right;">Price WeekEnd</th>
                    <th style="text-align:right;">Discount</th>
                    <th style="text-align:right;">Discount(%)</th>
                    <th style="text-align:right;">Tax</th>
                    <th style="text-align:center;">Currency</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, i) in listData" v-bind:key="i">
                    <td style="width:45px;text-align:right;">{{ startSequence + i + 1 }}</td>
                    <td style="width:85px;text-align:right;">
                      <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                        <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                      </a>
                      <a href="#" v-on:click="onEdit(row)" ref="editRow" style="padding-right:5px">
                        <span class="icon ion-edit" data-toggle="tooltip" data-placement="right" title="Edit"></span>
                      </a>
                      <!-- <a href="#" v-on:click="onDelete(row)" ref="deleteRow" style="padding-right:5px">
                        <span class="icon ion-ios-trash" data-toggle="tooltip" data-placement="right" title="Delete"></span>
                      </a> -->
                    </td>
                    <td style="text-align:left;">{{ row.productName }}</td>
                    <td style="text-align:center;">{{ row.validFrom }}</td>
                    <td style="text-align:center;">{{ row.time }}</td>
                    <td style="text-align:right;">{{ row.priceWeekDay }}</td>
                    <td style="text-align:right;">{{ row.priceWeekEnd }}</td>
                    <td style="text-align:right;">{{ row.discountPrice }}</td>
                    <td style="text-align:right;">{{ row.discountPercentage }}</td>
                    <td style="text-align:right;">{{ row.tax }}</td>
                    <td style="text-align:center;">{{ row.currencyName }}</td>
                    <td hidden>{{ row.id }}</td>
                    <td hidden>{{ row.productId }}</td>
                    <td hidden>{{ row.currencyId }}</td>
                    <td hidden>{{ row.courtScheduleId }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="box-footer">
              <div class="form-group">
                <label style="width:25px;text-align:right;">
                  <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
                </label>
                <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)"
                      class="icon ion-arrow-left-b"></i></a>
                </label>
                <label>
                  Page
                </label>
                <label>
                  <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)"
                    class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                </label>
                <label id="TotalPageText">
                  {{ totalPages }}
                </label>
                <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)"
                      class="icon ion-arrow-right-b"></i></a>
                </label>
                <label style="width:25px;text-align:left;">
                  <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div id="form" v-if="viewType == 'form'">
        <div class="row center-block">
          <div class="col-md-12">
            <div class="box no-border">
              <form @submit.prevent class="form-horizontal">
                <div class="box-body">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="inputProduct" class="col-sm-2 control-label">Product</label>
                        <div class="col-sm-10">
                          <select2
                            id="comboProduct"
                            v-model="formData.productId"
                            :options="productOptions"
                            :ajax="productAjax"
                            :minimumInputLength="3"
                            placeholder="Search product..."
                            :enable="viewMode != MODE_VIEW"
                            :multiple="false"
                            @change="onChangeProduct"
                            :style="{ 'width': '100%' }"
                          ></select2>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputValidFrom" class="col-sm-2 control-label">Valid From</label>
                        <div class="col-sm-10">
                          <div class="input-group">
                            <datepicker style="width:100%" v-if="showValidFrom" :readonly="true" name="validFrom"
                              :value=formData.validFrom :format=DATE_FORMAT
                              :input-attr="{ 'id': 'validFrom', 'disabled': viewMode == MODE_VIEW ? true : false }"
                              @change="onChangeProduct" :input-style="{ 'width': '100%' }"></datepicker>
                            <span class="input-group-addon">
                              <i class="icon ion-calendar"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputTime" class="col-sm-2 control-label">Time</label>
                        <div class="col-sm-10">
                          <!-- <input type="text" ref="inputTime" :readonly="viewMode == MODE_VIEW" class="form-control" id="inputTime" placeholder="" v-model="formData.time"> -->
                          <select v-model="formData.courtScheduleId" class="form-control"
                            :disabled="viewMode == MODE_VIEW ? true : false" @change="onChangeScheduleTime">
                            <option v-for="(row, i) in listTime" v-bind:key="i" v-bind:value="row.id">
                              {{ row.schedule_time }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputPriceWeekDay" class="col-sm-2 control-label">Price (WeekDay)</label>
                        <div class="col-sm-10">
                          <input type="text" @keyup="formattingNumber($event)" ref="inputPriceWeekDay"
                            :readonly="viewMode == MODE_VIEW" class="form-control" id="inputPriceWeekDay" placeholder=""
                            v-model="formData.priceWeekDay">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputPriceWeekEnd" class="col-sm-2 control-label">Price (WeekEnd)</label>
                        <div class="col-sm-10">
                          <input type="text" @keyup="formattingNumber($event)" ref="inputPriceWeekEnd"
                            :readonly="viewMode == MODE_VIEW" class="form-control" id="inputPriceWeekEnd" placeholder=""
                            v-model="formData.priceWeekEnd">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputDiscountPrice" class="col-sm-2 control-label">Discount</label>
                        <div class="col-sm-10">
                          <input type="text" @keyup="formattingNumber($event)" ref="inputDiscountPrice"
                            :readonly="viewMode == MODE_VIEW" class="form-control" id="inputDiscountPrice"
                            placeholder="" v-model="formData.discountPrice">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputDiscountPercentage" class="col-sm-2 control-label">Discount(%)</label>
                        <div class="col-sm-10">
                          <input type="text" @keyup="formattingNumber($event)" ref="inputDiscountPercentage"
                            :readonly="viewMode == MODE_VIEW" class="form-control" id="inputDiscountPercentage"
                            placeholder="" v-model="formData.discountPercentage">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputTax" class="col-sm-2 control-label">Tax</label>
                        <div class="col-sm-10">
                          <input type="text" @keyup="formattingNumber($event)" ref="inputTax"
                            :readonly="viewMode == MODE_VIEW" class="form-control" id="inputTax" placeholder=""
                            v-model="formData.tax">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="inputCurrency" class="col-sm-2 control-label">Currency</label>
                        <div class="col-sm-10">
                          <select v-model="formData.currencyId" class="form-control"
                            :disabled="viewMode == MODE_VIEW ? true : false">
                            <option v-for="(row, i) in listCurrency" v-bind:key="i" v-bind:value="row.id">
                              {{ row.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
                  <input type="hidden" class="form-control" id="inputCurrencyId" v-model="formData.currencyId">
                  <input type="hidden" class="form-control" id="inputCourtScheduleId"
                    v-model="formData.courtScheduleId">
                </div>
                <!-- /.box-body -->
                <div class="box-footer">
                  <div class="box-tools">
                    <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                    <button @click="onCancel()" class="btn btn-warning">Cancel</button>
                    <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)"
                      class="btn btn-info pull-right">Edit</button>
                    <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right"
                      style="margin-right:15px;">Create</button>
                  </div>
                </div>
                <!-- /.box-footer -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div class="modal fade" id="modal-filter" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="box-body no-border form-horizontal">
              <div class="form-group">
                <label class="col-md-2 control-label">Product Name</label>
                <div class="col-md-10">
                    <input type="text" id="filterProductName" v-model="searchParam.productName" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">ValidFrom Date</label>
                <div class="col-md-10">
                  <div class="input-group">
                    <datepicker v-if="showValidDateFrom" ref="validDateFrom" :value=searchParam.validDateFrom :format=DATE_FORMAT :input-attr="{ 'id': 'filterValidDateFrom' }" :input-style="{ 'width': '100%' }"></datepicker>
                    <label>to</label>
                    <datepicker v-if="showValidDateTo" ref="validDateTo" :value=searchParam.validDateTo :format=DATE_FORMAT :input-attr="{ 'id': 'filterValidDateTo' }" :input-style="{ 'width': '100%' }"></datepicker>
                  </div>
                </div>                     
              </div>                                                                                        
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="onApplyFilter($event)">Apply</button>
            <button type="button" class="btn btn-primary" @click="onResetFilter($event)">Reset</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import select2 from '../../components/widgets/Select2'
import config from '../../config'
import utilities from '../../utilities'
import axios from 'axios'
import moment from 'moment'

const VIEW_LIST = 'list'
const VIEW_FORM = 'form'
const MODE_NONE = 'none'
const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'

export default {
  name: 'Price',
  components: {
    datepicker,
    select2
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      DATE_FORMAT_SQL: config.dateFormatSql,
      DATETIME_FORMAT_ISO: config.dateTimeFormatSql,
      VIEW_LIST: VIEW_LIST,
      VIEW_FORM: VIEW_FORM,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      item: null,
      listData: null,
      listCurrency: null,
      listProduct: null,
      listTime: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        WhereClausePrice: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'ProductName'
      },
      searchParam: {
        productName: '',
        validDateFrom: '',
        validDateTo: ''
      },
      showValidDateFrom: true,
      showValidDateTo: true,
      viewType: VIEW_LIST,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        productId: 0,
        courtId: '',
        validFrom: '',
        time: '',
        priceWeekDay: 0,
        priceWeekEnd: 0,
        currencyId: 0,
        discountPrice: 0,
        discountPercentage: 0,
        tax: 0,
        courtScheduleId: ''
      },
      showValidFrom: false
    }
  },
  computed: {
    productOptions() {
      return this.listProduct ? this.listProduct.map(item => ({ id: item.id, text: item.name })) : []
    },
    productAjax() {
      const currentProjects = this.$store.state.userInfo.projects
      return {
        url: '/api/Product/Inquiry',
        dataType: 'json',
        delay: 250,
        data: params => {
          let whereClause = ''
          if (currentProjects && currentProjects.length > 0) {
            whereClause = 'ProjectId IN (' + currentProjects.join() + ')'
          }
          if (params.term && params.term.length > 0) {
            const sanitized = params.term.replace(/'/g, "''")
            const searchClause = "Name LIKE '%" + sanitized + "%'"
            whereClause = whereClause ? whereClause + ' AND ' + searchClause : searchClause
          }
          return {
            WhereClause: whereClause,
            PageSize: 100,
            CurrentPageNumber: 1,
            SortDirection: 'ASC',
            SortExpression: 'Name'
          }
        },
        processResults: data => {
          const results = (data.entity || []).map(item => ({ id: item.id, text: item.name, courtId: item.courtId }))
          return { results }
        },
        cache: true
      }
    }
  },
  created() {
    this.viewType = VIEW_LIST
    this.inquiry()
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
    this.$root.$on('inquiryPriceByProject', (projectIds) => {
      this.projectIds = projectIds
      return this.inquiry()
    })
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    formattingNumber(evt) {
      // When the arrow keys are pressed, etc..., abort.
      if ($.inArray(evt.keyCode, [9, 38, 40, 37, 39]) !== -1) {
        return
      }

      var input = this.$refs[evt.target.id].value
      var inputNumber = utilities.ParseNumber(input)
      this.$refs[evt.target.id].value = utilities.DisplayNumber(inputNumber)
      switch (evt.target.id) {
        case 'inputPriceWeekDay':
          this.formData.priceWeekDay = utilities.DisplayNumber(inputNumber)
          break
        case 'inputPriceWeekEnd':
          this.formData.priceWeekEnd = utilities.DisplayNumber(inputNumber)
          break
        case 'inputDiscountPrice':
          this.formData.discountPrice = utilities.DisplayNumber(inputNumber)
          break
        case 'inputDiscountPercentage':
          this.formData.discountPercentage = utilities.DisplayNumber(inputNumber)
          break
        case 'inputTax':
          this.formData.tax = utilities.DisplayNumber(inputNumber)
          break
        default:
          break
      }
    },
    getCurrency() {
      api
        .request('Account', 'get', '/api/Currency/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listCurrency = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProduct() {
      this.inquiryParam.WhereClauseByProject = ''
      var routeCondition = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
        routeCondition = api.request('Sales', 'get', '/api/Product/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
          '&PageSize=100&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
          '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=Name', null)
      } else {
        routeCondition = api.request('Sales', 'get', '/api/Product/InquiryAll', null)
      }
      routeCondition.then(response => {
        var data = response.data
        this.listProduct = data.entity
      })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onChangeProduct(evt) {
      const selectedProductId = evt && evt.target ? parseFloat(evt.target.value) : parseFloat(this.formData.productId)
      let product = this.listProduct.find(x => x.id === selectedProductId)
      if (product) {
        this.formData.courtId = product.courtId
        this.getCourtSchedule()
      }
    },
    getCourtSchedule() {
      this.listTime = [{
        id: '',
        court_id: '',
        seq_no: 0,
        schedule_time: '00:00:00',
        occupancy: 0,
        deletion_flag: false,
        product_id: 0
      }]
      if (this.formData.courtId !== '') {
        let validFrom = moment(this.formData.validFrom, this.DATE_FORMAT)
        validFrom = moment(validFrom).format(this.DATE_FORMAT_SQL)

        const requestCourtSchedule = api.request('Reservation', 'get', '/api/Reservation/Court/' + this.formData.courtId + '/Schedule', null)
        const requestPriceAlreadySetUp = api.request('Sales', 'get', '/api/Price/Inquiry?WhereClause=ProductId=' + this.formData.productId +
          ' AND Price.ValidFrom = \'' + validFrom + '\'' + '&PageSize=99999&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        axios
          .all([requestCourtSchedule, requestPriceAlreadySetUp])
          .then(
            axios.spread((...response) => {
              const responseCourtSchedule = response[0]
              const responsePriceAlreadySetUp = response[1]

              if (responseCourtSchedule.data.returnStatus && responsePriceAlreadySetUp.data.returnStatus) {
                this.listTime = responseCourtSchedule.data.entity

                responsePriceAlreadySetUp.data.entity.forEach(element => {
                  for (var i = 0; i < this.listTime.length; i++) {
                    if (this.listTime[i].id === element.courtScheduleId && this.listTime[i].id !== this.formData.courtScheduleId) {
                      this.listTime.splice(i, 1)
                    }
                  }
                })
              } else {
                let message = responseCourtSchedule.data.returnMessage.join('<br>') + '<br>' + responsePriceAlreadySetUp.data.returnMessage.join('<br>')
                SweetAlert.fire('Error', message, 'error')
              }
            })
          )
          .catch(error => {
            SweetAlert.fire('Error', error.message, 'error')
          })
      }
    },
    onChangeScheduleTime(evt) {
      // this.formData.courtScheduleId = evt.target.id
      // this.formData.time = evt.target.value
    },
    getMasterData() {
      this.getCurrency()
    },
    inquiry() {
      var thiss = this
      let p1 = new Promise((resolve, reject) => {
        thiss.getMasterData()
        setTimeout(resolve, 200)
      })

      p1.then(() => {
        thiss.inquiryPrice()
      })
    },
    inquiryPrice() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('Sales', 'get', '/api/Price/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
          '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
          '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages

          var currencyName
          this.listData.forEach(itemPrice => {
            currencyName = ''
            this.listCurrency.some(function (itemCurrency, index) {
              if (itemPrice.currencyId === itemCurrency.id) {
                currencyName = itemCurrency.name
              }
            })
            itemPrice.currencyName = currencyName
          })
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    initForm() {
      this.formData.id = 0
      this.formData.productId = 0
      this.formData.courtId = ''
      this.formData.validFrom = moment(new Date()).format(this.DATE_FORMAT)
      this.formData.time = ''
      this.formData.courtScheduleId = ''
      this.formData.priceWeekDay = 0
      this.formData.priceWeekEnd = 0
      this.formData.currencyId = 0
      this.formData.discountPrice = 0
      this.formData.discountPercentage = 0
      this.formData.tax = 0
      this.formData.courtScheduleId = ''

      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
    },
    onSearch(evt) {
      this.inquiryNew()
    },
    inquiryNew() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'ProjectId IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClausePrice === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }
      api
        .request('Sales', 'get', '/api/Price/Inquiry?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClausePrice +
          '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
          '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages

          var currencyName
          this.listData.forEach(itemPrice => {
            currencyName = ''
            this.listCurrency.some(function (itemCurrency, index) {
              if (itemPrice.currencyId === itemCurrency.id) {
                currencyName = itemCurrency.name
              }
            })
            itemPrice.currencyName = currencyName
          })
        })
        .catch(error => {
          var message = error.message
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onCreate() {
      this.initForm()
      this.viewType = VIEW_FORM
      this.viewMode = MODE_CREATE

      this.getProduct()
      this.getCurrency()
    },
    onDisplay(row) {
      this.viewType = VIEW_FORM
      this.viewMode = MODE_VIEW

      this.getProduct()
      this.getCurrency()

      this.formData.id = row.id
      this.formData.productId = row.productId
      this.formData.courtId = row.courtId
      this.formData.productName = row.productName
      this.formData.validFrom = row.validFrom
      this.formData.time = row.time
      this.formData.priceWeekDay = row.priceWeekDay
      this.formData.priceWeekEnd = row.priceWeekEnd
      this.formData.currencyId = row.currencyId
      this.formData.discountPrice = row.discountPrice
      this.formData.discountPercentage = row.discountPercentage
      this.formData.tax = row.tax
      this.formData.courtScheduleId = row.courtScheduleId

      this.getCourtSchedule()

      this.showValidFrom = false
      this.$nextTick(() => {
        this.showValidFrom = true
      })
    },
    onEdit(data) {
      let currentDate = moment().startOf('day')
      let validFrom = moment(data.validFrom, this.DATE_FORMAT).startOf('day')
      console.log('currentDate: ' + currentDate.format(this.DATE_FORMAT_SQL))
      console.log('validFrom: ' + validFrom.format(this.DATE_FORMAT_SQL))
      if (validFrom.isBefore(currentDate)) {
        SweetAlert.fire('Warning', 'This price can\'t be edited because the valid from date is before the current date', 'info')
        return
      } else {
        this.viewType = VIEW_FORM
        this.viewMode = MODE_UPDATE
        this.getProduct()
        this.getCurrency()

        this.formData.id = data.id
        this.formData.productId = data.productId
        this.formData.courtId = data.courtId
        this.formData.productName = data.productName
        this.formData.validFrom = data.validFrom
        this.formData.time = data.time
        this.formData.priceWeekDay = data.priceWeekDay
        this.formData.priceWeekEnd = data.priceWeekEnd
        this.formData.currencyId = data.currencyId
        this.formData.discountPrice = data.discountPrice
        this.formData.discountPercentage = data.discountPercentage
        this.formData.tax = data.tax
        this.formData.courtScheduleId = data.courtScheduleId

        this.getCourtSchedule()

        this.showValidFrom = false
        this.$nextTick(() => {
          this.showValidFrom = true
        })
      }
    },
    onDelete(data) {
      SweetAlert.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: true
      })
        .then((result) => {
          if (result.value) {
            var res = this.delete(data)
            SweetAlert.fire('Deleted', res.message, res.status)
          } else if (result.dismiss === SweetAlert.DismissReason.cancel) {
            SweetAlert.fire('Cancelled', 'Your data is still exist', 'info')
          }
        })
    },
    onCancel() {
      this.initForm()
    },
    onBack() {
      this.inquiry()
      this.viewType = VIEW_LIST
    },
    onSave() {
      let timeChoosen = this.listTime.find(x => x.id === this.formData.courtScheduleId)
      this.formData.time = timeChoosen === undefined ? '00:00:00' : timeChoosen.schedule_time

      var data = {
        Id: this.formData.id,
        ProductId: this.formData.productId,
        CourtId: this.formData.courtId,
        ValidFrom: $('#validFrom').val(), // this.formData.validFrom,
        Time: this.formData.time,
        PriceWeekDay: this.formData.priceWeekDay,
        PriceWeekEnd: this.formData.priceWeekEnd,
        DiscountPrice: this.formData.discountPrice,
        DiscountPercerntage: this.formData.discountPercentage,
        Tax: this.formData.tax,
        CurrencyId: this.formData.currencyId,
        CourtScheduleId: this.formData.courtScheduleId
      }

      var status = 'success'
      var message = ''
      var method = ''
      switch (this.viewMode) {
        case MODE_CREATE:
          method = 'Create'
          break
        case MODE_UPDATE:
          method = 'Update'
          break
      }

      api
        .request('Sales', 'post', '/api/Price/' + method, data)
        .then(response => {
          var resData = response.data
          this.formData = resData.entity
          this.total = resData.totalRows

          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage.join('<br>')
          SweetAlert.fire(status, message, status)

          if (resData.returnStatus) {
            this.onDisplay(this.formData)
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    delete(data) {
      var status = ''
      var message = ''
      var reqData = {
        Id: data.id
      }
      api.request('Sales', 'post', '/api/Price/Delete', reqData)
        .then(response => {
          var resData = response.data
          status = resData.returnStatus ? 'success' : 'error'
          message = resData.returnMessage
          this.inquiry()
        })
        .catch(error => {
          status = 'error'
          message = 'Error happens when call API delete: ' + error.message
        })
      return { status: status, message: message }
    },
    onApplyFilter() {
      var filterParams = []
      if (this.searchParam.productName !== '') {
        filterParams.push(['Product.Name', 'like', '\'%' + this.searchParam.productName + '%\''])
      }

      let dateFrom
      if ($('#filterValidDateFrom').val() === '') {
        dateFrom = moment('01.01.1900', this.DATE_FORMAT)
      } else {
        this.searchParam.validDateFrom = $('#filterValidDateFrom').val()
        dateFrom = moment(this.searchParam.validDateFrom, this.DATE_FORMAT)
      }
      dateFrom = moment(dateFrom).format(this.DATE_FORMAT_ISO) + ' 00:00:00'
      dateFrom = this.convertToUtcTime(dateFrom, this.DATETIME_FORMAT_ISO)
      filterParams.push(['Price.ValidFrom', '>=', '\'' + dateFrom + '\''])

      let dateTo
      if ($('#filterValidDateTo').val() === '') {
        dateTo = moment('31.12.9999', this.DATE_FORMAT)
      } else {
        this.searchParam.validDateTo = $('#filterValidDateTo').val()
        dateTo = moment(this.searchParam.validDateTo, this.DATE_FORMAT)
      }
      dateTo = moment(dateTo).format(this.DATE_FORMAT_ISO) + ' 00:00:00'
      dateTo = this.convertToUtcTime(dateTo, this.DATETIME_FORMAT_ISO)
      filterParams.push(['Price.ValidFrom', '<=', '\'' + dateTo + '\''])

      var whereClause = []
      var j = 0
      for (let i = 0; i < filterParams.length; i++) {
        whereClause[j] = filterParams[i].join(' ')
        j++
      }
      this.inquiryParam.WhereClausePrice = whereClause.join(' AND ')
      this.onSearch()
    },
    onResetFilter() {
      this.inquiryParam.WhereClause = ''
      this.searchParam.productName = ''

      this.searchParam.validDateFrom = ''
      this.searchParam.validDateTo = ''

      this.showValidDateFrom = false
      this.$nextTick(() => {
        this.showValidDateFrom = true
      })

      this.showValidDateTo = false
      this.$nextTick(() => {
        this.showValidDateTo = true
      })
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity .5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

input[type=text],
select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}

input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}
</style>



// WEBPACK FOOTER //
// Price.vue?21e4245a